import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false
        },
        mutations: {
            networkMode: 'always'
        }
    }
});
